import { FAQ_NODE_TYPES, FAQ_BASE_PATH } from '@/constants/faqRouterPathes'

/**
 * Create a FAQ's tree from categories and articles flat arrays
 * @param {Array} initArticles flat array of articles
 * @param {Array} initCategories flat array of categories
 * @returns {Object} tree
 */
export const create = (initArticles, initCategories) => {
    const categories = [...initCategories];
    const articles = [...initArticles];
    categories.sort((a, b) => b.attributes.serial_number - a.attributes.serial_number)
    articles.sort((a, b) => b.attributes.sort - a.attributes.sort)

    function getFilteredChildren(array, filterKey, parentId, parentPath, nodeType) {
        const maxIdx = array.length - 1
        const children = []

        for (let i = maxIdx; i >= 0; i--) {
            if (array[i].relationships[filterKey].data.id === parentId) {
                array[i].fullPath = `${parentPath}/${nodeType}-${array[i].id}`
                children.push(array.splice(i, 1)[0])
            }
        }
        return children;
    }

    function getChildren(categories, articles, parentId, parentPath) {
        const childrenCategories = getFilteredChildren(
            categories,
            'parent',
            parentId,
            parentPath,
            FAQ_NODE_TYPES.CATEGORY,
        )
        const childrenArticles = getFilteredChildren(
            articles,
            'article_category',
            parentId,
            parentPath,
            FAQ_NODE_TYPES.ARTICLE,
        )

        return ([
            ...childrenCategories.map(childNode => ({
                ...childNode,
                children: getChildren(categories, articles, childNode.id, childNode.fullPath)
            })),
            ...childrenArticles
        ]).sort((a, b) => a.attributes?.serialNumber - b.attributes?.serialNumber);
    }

    return categories.find((category, index) => {
        const parentId = category.relationships.parent.data.id;
        const isCategoryRoot = parentId === null;

        if (isCategoryRoot) {
            categories.splice(index, 1)
            category.isRoot = true
            category.fullPath = `${FAQ_BASE_PATH}/${FAQ_NODE_TYPES.CATEGORY}-${category.id}`
            category.children = getChildren(categories, articles, category.id, category.fullPath)
            return category;
        }
    });
}